import React from 'react';
import { Tooltip, Box, withStyles, allCardBrands, AcceptedCardBrand } from 'vopay';
import { useTranslation } from 'react-i18next';
import { Title } from 'UI';
import styles from './AcceptedCardBrandsTooltip.module.scss';

// Import card logos from local CardLogos folder
import visaLogo from './CardLogos/visa.svg';
import mastercardLogo from './CardLogos/mastercard.svg';
import amexLogo from './CardLogos/amex.svg';
import discoverLogo from './CardLogos/discover.svg';
import unionpayLogo from './CardLogos/unionpay.svg';

const classes = withStyles(styles);

export interface AcceptedCardBrandsTooltipProps {
  acceptedCardBrands?: AcceptedCardBrand[];
  position?: 'top' | 'bottom' | 'left' | 'right' | 'topLeft' | 'topRight' | 'bottomLeft';
  iconWidth?: string;
  buttonWidth?: string;
}

// Map card brands to their logo imports
const cardLogoMap: Record<AcceptedCardBrand, string> = {
  visa: visaLogo,
  mastercard: mastercardLogo,
  amex: amexLogo,
  discover: discoverLogo,
  unionpay: unionpayLogo,
};

const AcceptedCardBrandsTooltip: React.FC<AcceptedCardBrandsTooltipProps> = ({
  acceptedCardBrands,
  position = 'right',
  iconWidth = '10px',
  buttonWidth = '18px',
}) => {
  const { t } = useTranslation('translations', { keyPrefix: 'AcceptedCardBrandsTooltip' });

  // If no accepted card brands specified, show all brands
  const brandsToDisplay = acceptedCardBrands && acceptedCardBrands.length > 0 ? acceptedCardBrands : allCardBrands;

  const tooltipContent = (
    <Box gapSize="12px" flx="col" className={classes('tooltipContent')}>
      <Title emphasized level="6">
        {t('acceptedCardBrands')}
      </Title>
      <Box flx="row" ai="center" className={classes('cardLogos')}>
        {brandsToDisplay.map((brand) => (
          <img
            key={brand}
            src={cardLogoMap[brand]}
            alt={t(`cardBrands.${brand}`) || brand}
            className={classes('cardLogo')}
          />
        ))}
      </Box>
    </Box>
  );

  return (
    <span
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <Tooltip
        icon="info"
        variant="outlined"
        iconWidth={iconWidth}
        buttonWidth={buttonWidth}
        position={position}
        information={tooltipContent}
        hasArrow
        width="340px"
      />
    </span>
  );
};

export default AcceptedCardBrandsTooltip;
